<div class="ui-list">
  <ul>
    <li *ngFor="let item of items">
      <ng-container
        *ngTemplateOutlet="listItemRef; context: { $implicit: item }"
      ></ng-container>
    </li>
  </ul>
</div>
